import { Bold } from '@serodigital/ui-components';
import * as React from 'react';
import { DetailsStatus } from '../status';
import { WaterBoost } from './waterBoost';

interface IWaterStatusProps {
  isBoosted: boolean;
  isScheduled: boolean;
  temperature?: number;
  setpoint?: number;
  onToggle: (toggled: boolean) => void;
  disabled: boolean;
}

export function WaterStatus({ isBoosted, isScheduled, onToggle, setpoint, disabled }: IWaterStatusProps) {
  return (
    <DetailsStatus
      Title={<Bold className="text-brand-primary">Hot Water</Bold>}
      Status={<WaterBoost onToggle={onToggle} isScheduled={isScheduled} isBoosted={isBoosted} disabled={disabled} />}
      setpoint={setpoint}
      setpointTitle="Current setpoint"
    />
  );
}
